module.exports = __webpack_public_path__ + "img/high-risk-en.1487343b.png";